import { computed, inject, Injectable, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Observable, map, catchError, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

import { GetFile } from '../interfaces/file';
import { EmergencyAlerts } from '../interfaces/emergency-alerts';

@Injectable({
  providedIn: 'root',
})
export class EmergencyAlertsService {
  private apiUrl: string = `${environment.api}`;

  private http = inject(HttpClient);

  public alerts = signal<EmergencyAlerts[]>([]);

  public files = signal<GetFile[]>([]);

  constructor() {}

  getAllEmergencyAlerts(): Observable<EmergencyAlerts[]> {
    return this.http
      .get<EmergencyAlerts[]>(`${this.apiUrl}/Emergency/red-buttons-ii`)
      .pipe(
        map((alerts: EmergencyAlerts[]) => {
          return alerts.sort(
            (a: EmergencyAlerts, b: EmergencyAlerts) =>
              new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
          );
        }),
        catchError((err) => {
          console.error(err);
          return of([]);
        })
      );
  }
  getFiles(): Observable<GetFile[]> {
    return this.http.get<GetFile[]>(`${this.apiUrl}/MediaUpload/list`).pipe(
      map((files) => {
        return files.sort(
          (a, b) =>
            new Date(b.uploadedDate).getTime() -
            new Date(a.uploadedDate).getTime()
        );
      })
    );
  }

  setAlerts(alert: EmergencyAlerts[] | EmergencyAlerts) {
    this.alerts.update((value) =>
      Array.isArray(alert) ? [...alert, ...value] : [alert, ...value]
    );
  }
  setFiles(file: GetFile[] | GetFile) {
    this.files.update((value) =>
      Array.isArray(file) ? [...file, ...value] : [file, ...value]
    );
  }
}
